import { createBlankSpy } from 'domain/monitor'
import { useCreateMonitorMutation } from 'services/monitor'

export function useCreateSpy() {
    const [createMonitor] = useCreateMonitorMutation()

    const createSpy = async (locationList: string[]) => {
        const monitor = createBlankSpy()

        const result = await createMonitor({
            monitor: {
            ...monitor,
                ...{
                    locations: locationList
                }
            }
        })

        return result
    }

    return [ createSpy ]
}